import { needsScheduling } from '../../../utils/reminderHelpers';

const asId = (value) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0
    ? id
    : null;
};

export const reminderNeedsAttention = (reminder, now = new Date()) => {
  if (!reminder || !reminder.tag || reminder.tag.archived) return false;
  if (['Incomplete', 'PastDue', 'ScheduleMiss'].includes(reminder.status)) return true;
  return reminder.status === 'Unscheduled' && !!reminder.dueDate
    && new Date(reminder.dueDate).getTime() <= new Date(now).getTime();
};

export const buildReminderSummaries = (templates = [], reminders = [], activeTagIds = [], scope = {}) => {
  const activeIds = new Set([...activeTagIds].map(asId).filter(Boolean));
  const scopeIds = Array.isArray(scope.tagIds)
    ? new Set(scope.tagIds.map(asId).filter(Boolean))
    : null;
  const hasCutoff = !!scope.maxDueDate;
  const cutoff = new Date(scope.maxDueDate).getTime();
  const hasScope = scopeIds !== null || hasCutoff || !!scope.needsScheduling || !!scope.status;
  const uniqueReminders = new Map(reminders
    .filter((reminder) => reminder && asId(reminder.id))
    .map((reminder) => [asId(reminder.id), reminder]));
  const remindersByTemplate = new Map();

  uniqueReminders.forEach((reminder) => {
    const tagId = asId(reminder.tag?.id);
    if (!tagId || reminder.tag.archived || !activeIds.has(tagId)) return;
    if (scopeIds !== null && !scopeIds.has(tagId)) return;
    if (scope.status && reminder.status !== scope.status) return;
    if (scope.needsScheduling && !needsScheduling(reminder)) return;
    if (hasCutoff && (!reminder.dueDate || !(new Date(reminder.dueDate).getTime() <= cutoff))) return;
    const templateId = asId(reminder.eventTemplateReminder?.id);
    if (!templateId) return;
    if (!remindersByTemplate.has(templateId)) remindersByTemplate.set(templateId, []);
    remindersByTemplate.get(templateId).push(reminder);
  });

  const uniqueTemplates = new Map(templates
    .filter((template) => template && asId(template.id) && !template.archived && !template.eventTemplate?.archived)
    .map((template) => [asId(template.id), template]));
  const now = new Date();
  return [...uniqueTemplates.values()]
    .map((template) => {
      const matchingReminders = remindersByTemplate.get(asId(template.id)) || [];
      const attentionReminders = matchingReminders.filter((reminder) => reminderNeedsAttention(reminder, now));
      return {
        template,
        reminders: matchingReminders,
        attentionReminders,
        horseCount: new Set(matchingReminders.map((reminder) => asId(reminder.tag.id))).size,
        attentionCount: attentionReminders.length,
      };
    })
    .filter((summary) => !hasScope || summary.reminders.length > 0)
    .sort((left, right) => (left.template.eventTemplate?.name || '').localeCompare(right.template.eventTemplate?.name || '')
      || asId(left.template.id) - asId(right.template.id));
};
